import Footer from "./Footer";
import MainAfroEstetica from "./Main/MainAfroEstetica";
import Header from "./Header";

function AfroEstetica() {
    
    return(
        <div>
        <Header />
        <MainAfroEstetica />
        <Footer />
    </div>
    );
}
export default AfroEstetica;
